import React, { useState, useEffect } from 'react'
import { BrowserView, MobileView } from 'react-device-detect'
import Select from 'react-select'
import Container from '../../layout/container'
import useForm from '../../utils/useForm'
import { getUrlParameter } from '../../utils/getUrlParameter'
import { validate, validateStep1 } from '../../utils/LoginFormValidationRules'
import { Modal1, Modal2, Modal3 } from '../Modal/index'
import {
  FormStyle,
  Step,
  StepItem,
  Form,
  FormColumn,
  FormRow,
  Danger,
  Success,
  SuccessContainer,
  Button,
  Submit,
  CloseSuccess
} from './style'
import Loader from 'components/Loader'

export default function LinkForm() {
  const [cities, setCities] = useState([])
  const [activeModal, setActiveModal] = useState()
  const [token, setToken] = useState()

  const [URLorigin, setURLorigin] = useState()
  const [UTMsource, setUTMsource] = useState()
  const [UTMmedium, setUTMmedium] = useState()
  const [UTMcampaign, setUTMcampaign] = useState()
  const [UTMterm, setUTMterm] = useState()
  const [UTMcontent, setUTMcontent] = useState()

  const {
    values,
    errors,
    errorsStep1,
    step,
    confirmation,
    setConfirmation,
    checked1,
    handleChecked1,
    checked2,
    handleChecked2,
    checked3,
    handleChecked3,
    handleStep,
    handleStepReturn,
    handleChange,
    handleSelectChange,
    handleSubmit,
    loading
  } = useForm(register, validate, validateStep1)

  const loadCities = async () => {
    try {
      const res = await fetch('/.netlify/functions/getCities')
      const cities = await res.json()
      setCities(
        cities.map(({ municipio, codigo_mun_tu, codigo_gera, codigo_dept_tu }) => ({
          label: municipio,
          codigo_mun_tu,
          codigo_gera,
          codigo_dept_tu
        }))
      )
    } catch (err) {
      console.error(err)
    }
  }

  const getTokens = async () => {
    try {
      const res = await fetch('/.netlify/functions/getToken')
      const tokens = await res.json()
      setToken(tokens.access_token)
    } catch (err) {
      console.error(err)
    }
  }

  const getUTM = () => {
    try {
      let url_origin = window.location.href
      setURLorigin(url_origin)

      let utm_source = getUrlParameter('utm_source')
      setUTMsource(utm_source)

      let utm_medium = getUrlParameter('utm_medium')
      setUTMmedium(utm_medium)

      let utm_campaign = getUrlParameter('utm_campaign')
      setUTMcampaign(utm_campaign)

      let utm_term = getUrlParameter('utm_term')
      setUTMterm(utm_term)

      let utm_content = getUrlParameter('utm_content')
      setUTMcontent(utm_content)
    } catch (err) {
      console.error(err)
    }
  }

  const eighteenYearsAgo = new Date(new Date().setFullYear(new Date().getFullYear() - 18))
    .toISOString()
    .split('T')[0]

  function register() {
    console.log('No errors, submit callback called!')
  }

  useEffect(() => {
    getUTM()
    loadCities()
    getTokens()
  }, [URLorigin, UTMsource, UTMmedium, UTMcampaign, UTMterm, UTMcontent])

  return (
    <FormStyle id="registro">
      <Container>
        <h2>
          <span className="title">REGISTRATE</span>
          ¡Emprende <span className="pos-title">ahora!</span>
        </h2>
        {step !== 3 ? (
          <>
            <Step>
              <StepItem className={step === 1 || 2 ? 'active' : ''}>1</StepItem>
              <i className={step === 2 ? 'active' : ''}></i>
              <StepItem className={step === 2 ? 'active' : ''}>2</StepItem>
            </Step>

            <h3>{step === 1 ? 'Datos de contacto' : 'Información personal'}</h3>
            <p>
              La información que proporciones en este formulario, será utilizada en tu modelo de
              venta. Asegúrate que todos los datos sean correctos.
            </p>
          </>
        ) : (
          ''
        )}

        <Form onSubmit={handleSubmit}>
          <FormRow>
            <input type="text" name="token" value={(values.token = token)} className="hidden" />
            <input
              type="text"
              name="URLorigin"
              value={(values.URLorigin = URLorigin)}
              className="hidden"
            />
            <input
              type="text"
              name="UTMsource"
              value={(values.UTMsource = UTMsource)}
              className="hidden"
            />
            <input
              type="text"
              name="UTMmedium"
              value={(values.UTMmedium = UTMmedium)}
              className="hidden"
            />
            <input
              type="text"
              name="UTMcampaign"
              value={(values.UTMcampaign = UTMcampaign)}
              className="hidden"
            />
            <input
              type="text"
              name="UTMterm"
              value={(values.UTMterm = UTMterm)}
              className="hidden"
            />
            <input
              type="text"
              name="UTMcontent"
              value={(values.UTMcontent = UTMcontent)}
              className="hidden"
            />
          </FormRow>
          {step === 1 ? (
            <>
              <FormColumn>
                <label htmlFor="name">Nombre*:</label>
                <input
                  type="text"
                  name="name"
                  onKeyDown={(evt) =>
                    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].includes(evt.key) &&
                    evt.preventDefault()
                  }
                  className={`form-control ${errorsStep1.name && 'is-danger'}`}
                  value={values.name || ''}
                  onChange={handleChange}
                  tabindex="1"
                />
                {errorsStep1.name && <Danger>{errorsStep1.name}</Danger>}

                <MobileView>
                  <label htmlFor="apelido">Apellidos*:</label>
                  <input
                    type="text"
                    name="apelido"
                    onKeyDown={(evt) =>
                      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].includes(evt.key) &&
                      evt.preventDefault()
                    }
                    className={`form-control ${errorsStep1.apelido && 'is-danger'}`}
                    value={values.apelido || ''}
                    onChange={handleChange}
                    tabindex="2"
                  />

                  {errorsStep1.apelido && <Danger>{errorsStep1.apelido}</Danger>}
                </MobileView>

                <label htmlFor="date">Fecha de nacimiento*:</label>
                <input
                  type="date"
                  name="date"
                  max={eighteenYearsAgo}
                  className={`form-control ${errorsStep1.date && 'is-danger'}`}
                  value={values.date || ''}
                  onChange={handleChange}
                  tabindex="3"
                />

                {errorsStep1.date && <Danger>{errorsStep1.date}</Danger>}

                <label htmlFor="documentType">Tipo de documento*:</label>
                <select
                  tabindex="5"
                  name="documentType"
                  className={`form-control ${errorsStep1.documentType && 'is-danger'}`}
                  value={values.documentType || ''}
                  onChange={handleChange}
                >
                  <option value="" select="true"></option>
                  <option value="1">Cédula de ciudadanía</option>
                  <option value="2">Cédula de extranjería</option>
                </select>

                {errorsStep1.documentType && <Danger>{errorsStep1.documentType}</Danger>}

                <MobileView>
                  <label htmlFor="documentNumber">Número de documento*:</label>
                  <input
                    type="number"
                    name="documentNumber"
                    max={values.documentType === '1' ? '10' : '7'}
                    min={values.documentType === '1' ? '6' : '6'}
                    onKeyDown={(evt) =>
                      ['e', 'E', '+', '-'].includes(evt.key) && evt.preventDefault()
                    }
                    className={`form-control ${errorsStep1.documentNumber && 'is-danger'}`}
                    value={values.documentNumber || ''}
                    onChange={handleChange}
                    tabindex="6"
                  />
                  {errorsStep1.documentNumber && <Danger>{errorsStep1.documentNumber}</Danger>}
                </MobileView>
              </FormColumn>

              <FormColumn>
                <BrowserView>
                  <label htmlFor="apelido">Apellidos*:</label>
                  <input
                    type="text"
                    name="apelido"
                    onKeyDown={(evt) =>
                      ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].includes(evt.key) &&
                      evt.preventDefault()
                    }
                    className={`form-control ${errorsStep1.apelido && 'is-danger'}`}
                    value={values.apelido || ''}
                    onChange={handleChange}
                    tabindex="2"
                  />

                  {errorsStep1.apelido && <Danger>{errorsStep1.apelido}</Danger>}
                </BrowserView>

                <label htmlFor="email">E-mail*:</label>
                <input
                  type="email"
                  name="email"
                  className={`form-control ${errorsStep1.email && 'is-danger'}`}
                  value={values.email || ''}
                  onChange={handleChange}
                  tabindex="4"
                />

                {errorsStep1.email && <Danger>{errorsStep1.email}</Danger>}

                <BrowserView>
                  <label htmlFor="documentNumber">Número de documento*:</label>
                  <input
                    type="number"
                    name="documentNumber"
                    max={values.documentType === '1' ? '10' : '7'}
                    min={values.documentType === '1' ? '6' : '5'}
                    onKeyDown={(evt) =>
                      ['e', 'E', '+', '-'].includes(evt.key) && evt.preventDefault()
                    }
                    className={`form-control ${errorsStep1.documentNumber && 'is-danger'}`}
                    value={values.documentNumber || ''}
                    onChange={handleChange}
                    tabindex="6"
                  />
                  {errorsStep1.documentNumber && <Danger>{errorsStep1.documentNumber}</Danger>}
                </BrowserView>
              </FormColumn>
            </>
          ) : step === 2 ? (
            <>
              <FormColumn>
                <MobileView>
                  <label htmlFor="celular">Celular*:</label>
                  <div className="inputCelular">
                    <input
                      type="number"
                      name="celular"
                      onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value))
                          .toString()
                          .slice(0, 10)
                      }}
                      className={`form-control ${errors.celular && 'is-danger'}`}
                      value={values.celular || ''}
                      onChange={handleChange}
                      tabindex="8"
                    />
                  </div>

                  {errors.celular && <Danger>{errors.celular}</Danger>}
                </MobileView>

                <label htmlFor="ciudad">Ciudad*:</label>

                <Select
                  options={cities}
                  name="ciudad"
                  className={`${errors.ciudad && 'is-danger'}`}
                  value={values.ciudad || ''}
                  onChange={handleSelectChange}
                  tabindex="7"
                />

                {errors.ciudad && <Danger>{errors.ciudad}</Danger>}

                <FormRow>
                  <FormColumn>
                    <label htmlFor="direccion">Dirección*:</label>
                    <select
                      tabindex="9"
                      name="direccion"
                      className={`form-control ${errors.direccion && 'is-danger'}`}
                      value={values.direccion || ''}
                      onChange={handleChange}
                    >
                      <option value="" select="true"></option>
                      <option value="Calle">Calle</option>
                      <option value="Carrera">Carrera</option>
                      <option value="Transversal">Transversal</option>
                      <option value="Diagonal">Diagonal</option>
                      <option value="Avenida">Avenida</option>
                    </select>

                    {errors.direccion && <Danger>{errors.direccion}</Danger>}
                  </FormColumn>

                  <MobileView>
                    <FormColumn>
                      <label htmlFor="localNumber">Número*:</label>
                      <input
                        type="text"
                        name="localNumber"
                        className={`form-control ${errors.localNumber && 'is-danger'}`}
                        value={values.localNumber || ''}
                        onChange={handleChange}
                      />
                      {errors.localNumber && <Danger>{errors.localNumber}</Danger>}
                    </FormColumn>
                  </MobileView>

                  <BrowserView>
                    <FormColumn className="FormColumn--full">
                      <label htmlFor="complemento">Complemento*:</label>
                      <input
                        type="text"
                        name="complemento"
                        className={`form-control ${errors.complemento && 'is-danger'}`}
                        value={values.complemento || ''}
                        onChange={handleChange}
                        tabindex="10"
                      />

                      {errors.complemento && <Danger>{errors.complemento}</Danger>}
                    </FormColumn>
                  </BrowserView>
                </FormRow>

                <MobileView>
                  <FormRow className="FormRow--mobile">
                    <label htmlFor="complemento">Complemento*:</label>
                    <input
                      type="text"
                      name="complemento"
                      className={`form-control ${errors.complemento && 'is-danger'}`}
                      value={values.complemento || ''}
                      onChange={handleChange}
                      tabindex="10"
                    />

                    {errors.complemento && <Danger>{errors.complemento}</Danger>}
                  </FormRow>
                </MobileView>

                <label htmlFor="idReferencia">
                  ¿Alguién me refirió? - Puedes usar el nombre o el código:
                </label>
                <input
                  type="text"
                  name="idReferencia"
                  className="form-control"
                  value={values.idReferencia || ' '}
                  onChange={handleChange}
                  tabindex="13"
                />
              </FormColumn>

              <FormColumn>
                <BrowserView>
                  <label htmlFor="celular">Celular*:</label>
                  <div className="inputCelular">
                    <input
                      type="number"
                      name="celular"
                      onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value))
                          .toString()
                          .slice(0, 10)
                      }}
                      className={`form-control ${errors.celular && 'is-danger'}`}
                      value={values.celular || ''}
                      onChange={handleChange}
                      tabindex="8"
                    />
                  </div>

                  {errors.celular && <Danger>{errors.celular}</Danger>}
                </BrowserView>

                <FormRow>
                  <BrowserView>
                    <FormColumn className="FormColumn--full">
                      <label htmlFor="localNumber">Número*:</label>
                      <input
                        type="text"
                        name="localNumber"
                        className={`form-control ${errors.localNumber && 'is-danger'}`}
                        value={values.localNumber || ''}
                        onChange={handleChange}
                        tabindex="11"
                      />
                      {errors.localNumber && <Danger>{errors.localNumber}</Danger>}
                    </FormColumn>
                  </BrowserView>

                  <FormColumn>
                    <label htmlFor="localType">Apto / Casa / Edificio:</label>
                    <input
                      type="text"
                      name="localType"
                      className={`form-control ${errors.localType && 'is-danger'}`}
                      value={values.localType || ' '}
                      onChange={handleChange}
                      tabindex="12"
                    />
                    {errors.localType && <Danger>{errors.localType}</Danger>}
                  </FormColumn>
                </FormRow>

                <FormRow className="right">
                  <label htmlFor="acceptTerm1" className="acceptTerm">
                    <input
                      name="acceptTerm1"
                      id="acceptTerm1"
                      type="checkbox"
                      onChange={handleChecked1}
                      checked={checked1}
                    />
                    Acepto y autorizo el{' '}
                    <span onClick={() => setActiveModal(1)}>
                      {' '}
                      tratamiento de mis datos personales
                    </span>
                    .
                  </label>

                  <label htmlFor="acceptTerm2" className="acceptTerm">
                    <input
                      name="acceptTerm2"
                      id="acceptTerm2"
                      type="checkbox"
                      onChange={handleChecked2}
                      checked={checked2}
                    />
                    Acepto y autorizo el{' '}
                    <span onClick={() => setActiveModal(2)}>
                      {' '}
                      tratamiento de información financiera
                    </span>
                    .
                  </label>

                  <label htmlFor="acceptTerm3" className="acceptTerm">
                    <input
                      name="acceptTerm3"
                      id="acceptTerm3"
                      type="checkbox"
                      onChange={handleChecked3}
                      checked={checked3}
                    />
                    Acepto y autorizo el{' '}
                    <span onClick={() => setActiveModal(3)}>
                      {' '}
                      acuerdo comercial de venta directa
                    </span>
                    .
                  </label>
                </FormRow>
              </FormColumn>
            </>
          ) : (
            ''
          )}

          <FormRow>
            {step === 1 && <Button onClick={(e) => handleStep(e, 2)}>Siguiente</Button>}

            {step === 2 &&
              (!loading ? (
                <>
                  <Button type="submit" onClick={(e) => handleStepReturn(e, 1)}>
                    Regresar
                  </Button>
                  <Submit
                    type="submit"
                    primary={checked1 && checked2 && checked3 ? true : false}
                    disabled={checked1 && checked2 && checked3 ? false : true}
                  >
                    Enviar
                  </Submit>
                </>
              ) : (
                <Loader />
              ))}
          </FormRow>
        </Form>
      </Container>

      <>
        {activeModal === 1 ? (
          <Modal1 />
        ) : activeModal === 2 ? (
          <Modal2 />
        ) : activeModal === 3 ? (
          <Modal3 />
        ) : (
          ''
        )}

        {activeModal === 1 || activeModal === 2 || activeModal === 3 ? (
          <div className="overlay" onClick={() => setActiveModal()}></div>
        ) : (
          ''
        )}
      </>

      {confirmation && (
        <SuccessContainer>
          <Success>
            {confirmation && (
              <React.Fragment>
                <h4>¡Gracias!</h4>
                <h5>Hemos recibido tu solicitud</h5>
                <p>
                  En un periodo estimado de 24 horas estaremos comunicándonos contigo para ampliarte
                  toda la forma de información sobre como empreder con nosotros.
                </p>
                <CloseSuccess onClick={(_) => setConfirmation(false)}>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                      fill="black"
                    />
                  </svg>
                </CloseSuccess>
              </React.Fragment>
            )}
          </Success>
        </SuccessContainer>
      )}
    </FormStyle>
  )
}
